<template>
  <div class="container">
    <crumb prevLevel="生产数据监管" current="成品检验报告" />
    <div class="search">
      <el-form label-width="120px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="生产企业名称">
              <el-input
                v-model="queryParamsNum.entName"
                placeholder="请输入生产企业名称"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="药品通用名称">
              <el-input
                v-model="queryParamsNum.productName"
                placeholder="请输入药品通用名称"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="药品批准文号">
              <el-input
                v-model="queryParamsNum.appNo"
                placeholder="请输入药品批准文号"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="生产日期" label-width="90px">
              <el-date-picker
                v-model="stockTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                class="stockTime"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="药品性质">
              <el-select
                v-model="queryParamsNum.productType"
                placeholder="请选择"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="中成药" value="中成药"></el-option>
                <el-option label="化学药品" value="化学药品"></el-option>
                <el-option label="生物制药" value="生物制药"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="药品分类">
              <el-select
                v-model="queryParamsNum.isSpecial"
                placeholder="请选择"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="特药" value="1"></el-option>
                <el-option label="其他" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否OTC">
              <el-select
                v-model="queryParamsNum.isPrescribed"
                placeholder="请选择"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="处方药" value="处方药"></el-option>
                <el-option label="非处方药" value="非处方药"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="0">
              <el-button type="primary" style="margin-left:20px" @click="init()"
                >查询</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="statistic">
      <div class="title">成品检验报告数量统计</div>
      <div class="content">
        <div class="num-list">
          <div class="num-item">
            <div class="num">{{ ent_num }}</div>
            <div class="text">生产企业数量</div>
          </div>
          <div class="num-item">
            <div class="num">{{ report_num }}</div>
            <div class="text">成品检验报告数量</div>
          </div>
        </div>
        <Echarts :echartsOption="echartsOption" echartsHeight="400px" />
      </div>
    </div>
    <div class="table-list">
      <div class="title">成品检验报告列表</div>
      <el-table :data="supplierList" class="table">
        <el-table-column prop="entName" label="生产企业名称" />
        <el-table-column prop="productName" label="药品通用名称" />
        <el-table-column prop="inspection_number" label="药品批准文号" />
        <el-table-column prop="dosageform" label="剂型" />
        <!-- <el-table-column prop="" label="制剂规格" /> -->
        <el-table-column prop="specifications" label="规格" />
        <el-table-column prop="batch_number" label="生产批号" />
        <el-table-column prop="product_date" label="生产日期" />
        <el-table-column prop="validity_time" label="有效期" />
        <el-table-column label="检验报告">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="font-size: 12px"
              @click="handleClick(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        layout="total, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import Echarts from 'components/echarts/echarts';
import Crumb from 'components/crumb/crumb';
import paginationMixin from './pagination.mixin';

export default {
  data() {
    return {
      ent_num: '',
      report_num: '',
      stockTime: '',
      queryParamsNum: {
        entName: '',
        productName: '',
        appNo: '',
        productType: '',
        isSpecial: '',
        isPrescribed: ''
      },
      echartsOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: {
              show: false,
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              rotate: 30,
              textStyle: {
                color: '#666'
              }
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(206,219,239,0.5)'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#999'
              }
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(206,219,239,0.5)'
              }
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(206,219,239,0.5)'
              }
            }
          }
        ],
        series: [
          {
            type: 'bar',
            barWidth: '27px',
            itemStyle: {
              color: '#386CE2'
            },
            data: [10, 52, 200, 334, 390, 330, 220]
          }
        ]
      },
      supplierList: []
    };
  },
  mixins: [paginationMixin],
  components: {
    Echarts,
    Crumb
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.queryParams();
      this.EchartsData();
    },
    // 列表
    queryParams() {
      const obj = {
        entName: this.queryParamsNum.entName,
        productName: this.queryParamsNum.productName,
        appNo: this.queryParamsNum.appNo,
        productType: this.queryParamsNum.productType,
        isSpecial: this.queryParamsNum.isSpecial,
        isPrescribed: this.queryParamsNum.isPrescribed,
        startDate: this.stockTime ? this.stockTime[0] : '',
        endDate: this.stockTime ? this.stockTime[1] : ''
      };
      this.$request({
        url: 'open/production/qualityReportList',
        data: {
          json: JSON.stringify({
            pageBean: { pageNum: this.currentPage, pageSize: this.pageSize },
            params: obj
          })
        }
      }).then(res => {
        this.supplierList = res.list ? [...res.list] : [];
        this.total = res ? res.total : 0;
      });
    },
    // ecarts 柱状图
    EchartsData() {
      const xData = [];
      const yData = [];
      this.$request({
        url: 'open/production/qualityDetailStatics',
        data: {
          json: JSON.stringify({
            dict: {},
            params: {
              ...this.queryParamsNum,
              startDate: this.stockTime ? this.stockTime[0] : '',
              endDate: this.stockTime ? this.stockTime[1] : ''
            }
          })
        }
      }).then(res => {
        this.ent_num = res.ent_num ? res.ent_num : '';
        this.report_num = res.report_num ? res.report_num : '';
        res.list.forEach(item => {
          xData.push(item.organName);
          yData.push(item.num);
        });
        this.echartsOption.xAxis[0].data = xData;
        this.echartsOption.series[0].data = yData;
      });
    },
    // pdf查看详情
    handleClick(row) {
      this.$blobFileRequest({
        url: 'reportinfo/productQualityFile',
        data: {
          id: row.id
        },
        isPdfView: true
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import './common.styl'
.stockTime
  width 100% !important
</style>
